<template>
  <div v-if="tabList.length > 1 || showOneTab" >
    <vs-tabs :value="tabIndex">
      <vs-tab v-for="tab in tabList" :key="`tab_${tab.label}`" :label="tab.label" @click="moveTab(tab.boardId, tab.key)">
        <component v-if="tab.exception" :is="tab.component" />
        <component v-else-if="tab.listType" :is="tab.listType" />
        <table-list-page
          v-else-if="tab.isApproval"

          :board-id="tab.boardId"
          :board-slug="tab.slug"
          route-c="write|tab"
          route-u="write|update|tab"

          :download="false"
          :create="useCreate"
          :approval="true"
          :move-project="!(projectId > 0)"
          :by-current-location="tab.byCurrentLocation"

          :nav="nav"
          :heads="heads"
          :getCol="getCol"

          @load="onLoadData"
        >
          <template #search>
            <component :is="searchComponent" :value="nav.value" @input="onChangeSearch"/>
          </template>
          <template #targets>
            <search-nav-item-tartgets v-if="nav.value && nav.value.companies" v-model="nav.value.companies"/>
          </template>
        </table-list-page>
        <table-list-page
          v-else

          :board-id="tab.boardId"
          route-c="write|tab"
          route-u="write|update|tab"

          :download="false"
          :create="useCreate"
          :approval="false"
          :move-project="!(projectId > 0)"
          :by-current-location="tab.byCurrentLocation"

          :nav="nav"
          :heads="heads"
          :getCol="getCol"
        >
          <template #search>
            <component :is="searchComponent" :value="nav.value" @input="onChangeSearch"/>
          </template>
          <template #targets>
            <search-nav-item-tartgets v-if="nav.value && nav.value.companies" v-model="nav.value.companies"/>
          </template>
        </table-list-page>
      </vs-tab>
    </vs-tabs>
  </div>
  <div v-else-if="tabList.length === 1">
    <div v-for="tab in tabList" :key="`tab_${tab.label}`">
      <component v-if="tab.exception" :is="tab.component"/>
      <component v-else-if="tab.listType" :is="tab.listType" />
      <table-list-page
        v-else-if="tab.isApproval"

        :board-id="tab.boardId"
        :board-slug="tab.slug"
        route-c="write|tab"
        route-u="write|update|tab"

        :download="false"
        :create="useCreate"
        :approval="true"
        :move-project="!(projectId > 0)"
        :by-current-location="tab.byCurrentLocation"

        :nav="nav"
        :heads="heads"
        :getCol="getCol"

        @load="onLoadData"
      >
        <template #search>
          <component :is="searchComponent" :value="nav.value" @input="onChangeSearch"/>
        </template>
        <template #targets>
          <search-nav-item-tartgets v-if="nav.value && nav.value.companies" v-model="nav.value.companies"/>
        </template>
      </table-list-page>
      <table-list-page
        v-else

        :board-id="tab.boardId"
        route-c="write|tab"
        route-u="write|update|tab"

        :download="false"
        :create="useCreate"
        :approval="false"
        :move-project="!(projectId > 0)"
        :by-current-location="tab.byCurrentLocation"

        :nav="nav"
        :heads="heads"
        :getCol="getCol"
      >
        <template #search>
          <component :is="searchComponent" :value="nav.value" @input="onChangeSearch"/>
        </template>
        <template #targets>
          <search-nav-item-tartgets v-if="nav.value && nav.value.companies" v-model="nav.value.companies"/>
        </template>
      </table-list-page>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/views/boards/tab/breadcrumb'
import tabItems from '@/views/boards/tab/tab-items'
import TableListPage from '@/views/list/TableListPage'
import SearchNavYearMonth from '@/views/list/components/SearchNavYearMonth'
import SearchNavItemProject from '@/components/nav/SearchNavItemProject'
import Exception01 from '@/views/boards/exception/Exception01'
import Exception02 from '@/views/boards/exception/Exception02'
import Exception03 from '@/views/boards/exception/Exception03'
import Exception04 from '@/views/boards/exception/Exception04'
import moment from 'moment'

import normalSearchNav from '@/views/boards/components'
import singlePageList from '@/views/boards/single-page/listIndex'

import SearchNavItemTartgets from '@/views/boards/components/SearchNavItemTartgets'

export default {
  name: 'List',
  components:{
    SearchNavItemTartgets,
    SearchNavItemProject,
    SearchNavYearMonth,
    TableListPage,
    Exception01,
    Exception02,
    Exception03,
    Exception04,
    'List137': () => import('@/views/boards/single-page/137/List137'),

  },
  data () {
    return {
      breadcrumb,
      tabItems,
      tabIndex: 0,
      tabList: [],
      nav: {
        projectId: 0,
        orderTarget: parseInt(this.$route.params.boardId) === 299 ? 'updated_at' : 'created_at',
        orderDirection: 'desc',
        date: {year: new Date().getFullYear(), month:''},
        value: {},
        page: {},
        keyword: [],
      },
      create: true,
      companyList: [],
    }
  },
  computed: {
    useCreate () {
      return this.projectId > 0 && this.create
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    boardId () {
      return parseInt(this.$route.params.boardId)
    },
    projectId () {
      return this.$route.params.proj_id
    },
    searchComponent () {
      return normalSearchNav[`NormalSearchNav${this.boardId}`]
    },
    heads () {
      if (singlePageList[`${this.boardId}_list`]) {
        const head =  singlePageList[`${this.boardId}_list`].getHead(this.projectId)

        if (parseInt(this.projectId) === 5) {
          if (head.length > 0 && head[0].name === '사업장명') {
            head[0].name = '시설물명';
          }
        }
        return head;
      }

      return []
    },
    showOneTab () {
      const enabledIds = [286];

      // 탭이 노출되기 원하는 boardId인 경우
      // true를 반환시켜준다.
      return !!enabledIds.find((id) => id === this.boardId);
    }
  },
  beforeMount () {
    this.nav.projectId = this.projectId
    this.initBreadcrumb()
    this.initSearchKeyValue()
    this.initTab()
  },
  async mounted () {
    await this.loadCompanyList()
  },
  methods: {
    async loadCompanyList () {
      const page = 1
      const perPage = 10000
      const projectId = this.projectId
      await this.$store.dispatch('company/LOAD_COMPANY_LIST', {
        page,
        perPage,
        projectId
      })
      this.companyList = this.$store.state.company.companyList

      await this.$store.dispatch('company/LOAD_COMPANY_TREE', {projectId})
    },
    getCompanyName (comId) {
      for (const com of this.companyList) {
        if (com.id === comId) {
          return com.com_name
        }
      }
    },
    initTab () {
      if (this.boardId === 53 || this.boardId === 54 || this.boardId === 55) {
        this.addTab(53)
        this.addTab(54)
        this.addTab(55)
        if (this.boardId === 53) this.tabIndex = 0
        else if (this.boardId === 54) this.tabIndex = 1
        else if (this.boardId === 55) this.tabIndex = 2

      } else if (this.boardId === 58 || this.boardId === 59 || this.boardId === 60) {
        this.addTab(58)
        this.addTab(59)
        this.addTab(60)
        if (this.boardId === 58) this.tabIndex = 0
        else if (this.boardId === 59) this.tabIndex = 1
        else if (this.boardId === 60) this.tabIndex = 2

      } else if (this.boardId === 62 || this.boardId === 63) {
        this.addTab(62)
        this.addTab(63)
        this.addSubTab('아차사고D/B')
        if (this.boardId === 62) this.tabIndex = 0
        else if (this.boardId === 63) this.tabIndex = 1

      } else if (this.boardId === 64 || this.boardId === 65 || this.boardId === 66 || this.boardId === 67 || this.boardId === 68 || this.boardId === 69) {
        this.addTab(64)
        this.addTab(65)
        this.addTab(66)
        this.addTab(67)
        this.addTab(68)
        this.addTab(69)
        if (this.boardId === 64) this.tabIndex = 0
        else if (this.boardId === 65) this.tabIndex = 1
        else if (this.boardId === 66) this.tabIndex = 2
        else if (this.boardId === 67) this.tabIndex = 3
        else if (this.boardId === 68) this.tabIndex = 4
        else if (this.boardId === 69) this.tabIndex = 5

      } else if (this.boardId === 71 || this.boardId === 72 || this.boardId === 73 || this.boardId === 74 || this.boardId === 75) {
        this.addTab(74)
        this.addTab(75)
        this.addTab(71)
        this.addTab(72)
        this.addTab(73)
        if (this.boardId === 74) this.tabIndex = 0
        else if (this.boardId === 75) this.tabIndex = 1
        else if (this.boardId === 71) this.tabIndex = 2
        else if (this.boardId === 72) this.tabIndex = 3
        else if (this.boardId === 73) this.tabIndex = 4

      } else if (this.boardId === 76 || this.boardId === 77) {
        this.addTab(76)
        this.addTab(77)
        this.addSubTab('형태별분류')
        if (this.boardId === 76) this.tabIndex = 0
        else if (this.boardId === 77) this.tabIndex = 1

      } else if (this.boardId === 78 || this.boardId === 79 || this.boardId === 87) {
        this.addTab(78)
        this.addTab(79)
        this.addTab(87)
        if (this.boardId === 78) this.tabIndex = 0
        else if (this.boardId === 79) this.tabIndex = 1
        else if (this.boardId === 87) this.tabIndex = 2

      } else if (this.boardId === 80 || this.boardId === 81 || this.boardId === 88) {
        this.addTab(80)
        this.addTab(81)
        this.addTab(88)
        if (this.boardId === 80) this.tabIndex = 0
        else if (this.boardId === 81) this.tabIndex = 1
        else if (this.boardId === 88) this.tabIndex = 2

      } else if (this.boardId === 82 || this.boardId === 83) {
        this.addTab(82)
        this.addTab(83)
        if (this.boardId === 82) this.tabIndex = 0
        else if (this.boardId === 83) this.tabIndex = 1

      } else if (this.boardId === 84 || this.boardId === 85) {
        this.addTab(84)
        this.addTab(85)
        if (this.boardId === 84) this.tabIndex = 0
        else if (this.boardId === 85) this.tabIndex = 1

      } else if (this.boardId === 89) {
        this.addTab(89)
        this.addSubTab('조직도')
        if (this.boardId === 89) this.tabIndex = 0

      } else if (parseInt(this.projectId) === 1 && (this.boardId === 286 || this.boardId === 287)) {
        this.addTab(286)
        this.addTab(287)

        if (this.boardId === 286) this.tabIndex = 0
        if (this.boardId === 287) this.tabIndex = 1

      } else if (parseInt(this.projectId) === 2 && (this.boardId === 129 || this.boardId === 130)) {
        this.addTab(130)
        this.addTab(129)

        if (this.boardId === 130) this.tabIndex = 0
        if (this.boardId === 129) this.tabIndex = 1

      } else if ((parseInt(this.projectId) === 3 || parseInt(this.projectId) === 4 || parseInt(this.projectId) === 5) && (this.boardId === 129 || this.boardId === 130)) {
        this.addTab(130)
        this.addTab(129)

        if (this.boardId === 130) this.tabIndex = 0
        if (this.boardId === 129) this.tabIndex = 1

      } else if (parseInt(this.projectId) !== 3 && (this.boardId === 129 || this.boardId === 287)) {
        this.addTab(287)
        this.addTab(129)
        if (this.boardId === 287) this.tabIndex = 0
        if (this.boardId === 129) this.tabIndex = 1
      } else if (this.boardId === 108 || this.boardId === 156 || this.boardId === 157 || this.boardId === 158 || this.boardId === 159 || this.boardId === 305 || this.boardId === 306) {
        this.addTab(108)
        this.addTab(156)
        this.addTab(157)
        this.addTab(158)
        this.addTab(159)
        this.addTab(305)
        this.addTab(306)
        if (this.boardId === 108) this.tabIndex = 0
        if (this.boardId === 156) this.tabIndex = 1
        if (this.boardId === 157) this.tabIndex = 2
        if (this.boardId === 158) this.tabIndex = 3
        if (this.boardId === 159) this.tabIndex = 4
        if (this.boardId === 305) this.tabIndex = 5
        if (this.boardId === 306) this.tabIndex = 6

      } else if (this.boardId === 119 || this.boardId === 120 || this.boardId === 121 || this.boardId === 122 || this.boardId === 123 || this.boardId === 124 || this.boardId === 125) {
        this.addTab(119)
        this.addTab(120)
        // this.addTab(121) // 해당 탭을 숨겨 달라는 요청이 있었음..
        this.addTab(122)
        this.addTab(123)
        // this.addTab(124) // 2022.12.19 https://app.clickup.com/t/864dhnpjc
        this.addTab(125)
        if (this.boardId === 119) this.tabIndex = 0
        else if (this.boardId === 120) this.tabIndex = 1
        // else if (this.boardId === 121) this.tabIndex = 2 // 해당 탭을 숨겨 달라는 요청이 있었음..
        else if (this.boardId === 122) this.tabIndex = 2
        else if (this.boardId === 123) this.tabIndex = 3
        else if (this.boardId === 124) this.tabIndex = 4
        else if (this.boardId === 125) this.tabIndex = 5

      } else if (this.boardId === 144 || this.boardId === 145 || this.boardId === 146) {
        this.addTab(144)
        this.addTab(145)
        this.addTab(146)
        if (this.boardId === 144) this.tabIndex = 0
        if (this.boardId === 145) this.tabIndex = 1
        if (this.boardId === 146) this.tabIndex = 2

      } else if (this.boardId === 216 || this.boardId === 217 || this.boardId === 218) {
        this.addTab(216)
        this.addTab(217)
        this.addTab(218)
        if (this.boardId === 216) this.tabIndex = 0
        if (this.boardId === 217) this.tabIndex = 1
        if (this.boardId === 218) this.tabIndex = 2

      } else if (this.boardId === 239 || this.boardId === 240 || this.boardId === 241) {
        this.addTab(239)
        this.addTab(240)
        this.addTab(241)
        if (this.boardId === 239) this.tabIndex = 0
        if (this.boardId === 240) this.tabIndex = 1
        if (this.boardId === 241) this.tabIndex = 2

      } else if (this.boardId === 265 || this.boardId === 266) {
        this.addTab(265)
        this.addTab(266)
        if (this.boardId === 265) this.tabIndex = 0
        if (this.boardId === 266) this.tabIndex = 1

      } else if (this.boardId === 268 || this.boardId === 269) {
        this.addTab(268)
        this.addTab(269)
        if (this.boardId === 268) this.tabIndex = 0
        if (this.boardId === 269) this.tabIndex = 1

      } else if (this.boardId === 270 || this.boardId === 271) {
        this.addTab(270)
        this.addTab(271)
        if (this.boardId === 270) this.tabIndex = 0
        if (this.boardId === 271) this.tabIndex = 1

      } else if (this.boardId === 272 || this.boardId === 273) {
        this.addTab(272)
        this.addTab(273)
        if (this.boardId === 272) this.tabIndex = 0
        if (this.boardId === 273) this.tabIndex = 1

      } else if (this.boardId === 275 || this.boardId === 276 || this.boardId === 277 || this.boardId === 278) {
        this.addTab(275)
        this.addTab(276)
        this.addTab(277)
        this.addTab(278)
        if (this.boardId === 275) this.tabIndex = 0
        if (this.boardId === 276) this.tabIndex = 1
        if (this.boardId === 277) this.tabIndex = 2
        if (this.boardId === 278) this.tabIndex = 3

      } else if (this.boardId === 294 || this.boardId === 295) {
        this.addTab(294)
        this.addTab(295)
        if (this.boardId === 294) this.tabIndex = 0
        if (this.boardId === 295) this.tabIndex = 1
      } else if (this.boardId === 367 || this.boardId === 368 || this.boardId === 369) {
        this.addTab(367)
        this.addTab(368)
        this.addTab(369)
        if (this.boardId === 367) this.tabIndex = 0
        if (this.boardId === 368) this.tabIndex = 1
        if (this.boardId === 369) this.tabIndex = 2
      } else {
        this.addTab(this.boardId)
      } /*else if (this.boardId === 285 || this.boardId === 282 || this.boardId === 283) {
        this.addTab(285)
        this.addTab(282)
        this.addTab(283)
        if (this.boardId === 285) this.tabIndex = 0
        if (this.boardId === 282) this.tabIndex = 1
        if (this.boardId === 283) this.tabIndex = 2
      }*/
    },
    initBreadcrumb () {
      const breadcrumb = [{title: 'Home'}]
      let key = `${this.boardId}`;

      // 브래드크럼의 이름이 프로젝트 번호와 연결되어 있으면, 해당 정보를 가져온다
      if (this.breadcrumb[`${this.projectId}.${this.boardId}`]) {
        key = `${this.projectId}.${this.boardId}`;
      }
      breadcrumb.push(...this.breadcrumb[key])

      if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true

      this.$store.commit('menu/UPDATE_PAGE_LIST', breadcrumb)
    },
    initSearchKeyValue () {
      let keyValue = {}
      let keyword = []

      if (singlePageList[`${this.boardId}_list`]) {
        keyValue = singlePageList[`${this.boardId}_list`].getSearchKeyValue(this.nav)
        keyword = singlePageList[`${this.boardId}_list`].getSearchKeyword(this.nav)
      }

      if (keyword) {
        keyword = keyword.map((_keyword) => {
          return _keyword
            .replace('default_skw', `nav.page.p${this.$route.params.boardId}.searchKeyword`)
            .replace('default_disaster', `nav.page.p${this.$route.params.boardId}.disasterType`)
        })
      }

      this.nav.page[`p${this.boardId}`] = keyValue
      this.nav.keyword = keyword
    },
    addTab (_boardId) {
      const slug = `board-${_boardId}`
      const component = `singlePage${_boardId}`
      const boardId = `${_boardId}`
      const item = this.tabItems[boardId]
      if (item) {
        this.tabList.push({boardId, slug, component, ...item })
      }
    },
    addSubTab (key) {
      if (key === '아차사고D/B') this.tabList.push({key: '아차사고D/B', label: '아차사고 D/B', component: 'exception01', exception: true })
      if (key === '형태별분류') this.tabList.push({key: '형태별분류', label: '형태별 분류', component: 'exception02', exception: true })
      if (key === '조직도') this.tabList.push({key: '조직도', label: '조직도', component: 'exception03', exception: true })
      if (key === '현장대리인_안전보건_경영방침') this.tabList.push({key: '현장대리인_안전보건_경영방침', label: '현장대리인 안전보건 경영방침', component: 'exception04', exception: true })
    },
    moveTab (boardId, key) {
      if (boardId) {
        if (this.projectId) {
          this.$router.push({ name: 'list|tab', params: {boardId}})
        } else {
          this.$router.push({ name: 'root|list|tab', params: {boardId}})
        }
      }
      if (key) {
        if (key === '아차사고D/B') {
          const breadcrumb = [{title: '아차사고'}, {title: '아차사고관리'}, {title: '아차사고 D/B'}]
          if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true
          this.$store.commit('menu/UPDATE_PAGE_LIST', breadcrumb)
        } else if (key === '현장대리인_안전보건_경영방침') {
          this.$router.push({ name: 'list|tab', params: {boardId:'현장대리인_안전보건_경영방침'}})
        }
      }
    },

    getCol (index, value) {
      if (singlePageList[`${this.boardId}_list`]) {
        return singlePageList[`${this.boardId}_list`].getCol(index, value, {
          getContent: this.getContent,
          getCreatedDate: this.getCreatedDate,
          getCompanyName: this.getCompanyName,
          getContentTargetList: this.getContentTargetList,
          onNameBlur: this.onNameBlur,
          getContentRiskList: this.getContentRiskList,
          getContentStringList: this.getContentStringList,
          comma: this.comma,
        })
      }

      return ''
    },

    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },
    getCreatedDate (data) {
      if (data === '') return '';
      return moment(data).format('YYYY-MM-DD');
    },
    getContentStringList (list) {
      let result = ''
      for (const data of list) {
        if (!result.includes(data)) {
          result += `${data},`
        }
      }
      return result.substring(0, result.length - 1)
    },
    getContentRiskTypeList (list) {
      let result = ''
      for (const data of list) {
        if (!result.includes(data.input_1)) {
          result += `${data.input_1},`
        }
      }
      return result.substring(0, result.length - 1)
    },
    getContentRiskList (list) {
      let result = ''
      for (const data of list) {
        if (!result.includes(data.input_3)) {
          result += `${data.input_3},`
        }
      }
      return result.substring(0, result.length - 1)
    },
    getContentInspectionList (list) {
      let result = ''
      for (const data of list) {
        if (!result.includes(data.disaster)) {
          result += `${data.disaster},`
        }
      }
      return result.substring(0, result.length - 1)
    },
    getContentTargetList (list) {
      let result = ''
      for (const data of list) {
        if (!result.includes(data.target)) {
          result += `${data.target},`
        }
      }
      return result.substring(0, result.length - 1)
    },

    onChangeSearch (value) {
      this.nav.value = value
      this.initSearchKeyValue()
    },

    checkCreatable (list) {
      const nowMonth = new Date().getMonth() + 1
      let maxMonth = 0
      for (const data of list) {
        if (data.user.company_id === this.myInfo.company_id) {
          if (maxMonth < Number(`${this.getHeader(data).month}`)) {
            maxMonth = Number(`${this.getHeader(data).month}`)
          }
        }
      }
      return (maxMonth < nowMonth)
    },

    onLoadData (list) {
      if (this.boardId === 86 || this.boardId === 106 || this.boardId === 154 || this.boardId === 155 || this.boardId === 250) {
        this.create = this.checkCreatable(list)
      }
    },

    comma (str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    onNameBlur (name) {
      const length = name.length
      if (2 < length) {
        const first = name[0]
        const last = name[name.length - 1]
        let star = ''
        for (let index = 0; index < length - 2; index++) {
          star += '*'
        }
        name = first + star + last
      } else if (length === 2) {
        const first = name[0]
        name = `${first  }*`
      }
      return name
    },
  }
}
</script>

<style scoped>

</style>
